import { render } from "./Users.vue?vue&type=template&id=afa70512"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "./Users.vue?vue&type=style&index=0&id=afa70512&lang=css"
script.render = render

export default script